<template>
  <div class="history-card">
    <h2>История опросов</h2>
    
    <div v-if="loading" class="loading">
      Загрузка...
    </div>

    <div v-else-if="surveys.length === 0" class="empty">
      Опросов не найдено
    </div>

    <div v-else class="surveys-list">
      <div 
        v-for="survey in surveys"
        :key="survey.id"
        class="survey-item"
        @click="selectSurvey(survey)"
      >
        <div class="survey-info">
          <h3>Опрос от {{ formatDate(survey.date) }}</h3>
          <p class="survey-meta">
            Проводил: {{ survey.conducted_by_name }} | 
            Статус: <span :class="`status-${survey.status}`">{{ statusLabel(survey.status) }}</span> |
            Участников: {{ survey.participants.length }}
          </p>
          <p class="survey-questions">Вопросов: {{ survey.question_set_name }}</p>
        </div>
        <div v-if="survey.has_result || survey.result_id || survey.result" class="survey-action">
          <button class="btn-view">Просмотреть результаты →</button>
        </div>
        <div v-else class="survey-action">
          <span class="status-no-result">Результаты не готовы</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getRecentSurveys, getSurvey, getSurveyResult } from '@/api/mpo'

export default {
  name: 'SurveyHistory',
  emits: ['survey-selected'],
  data() {
    return {
      surveys: [],
      loading: true,
      error: null,
    }
  },
  mounted() {
    this.loadSurveys()
  },
  methods: {
    async loadSurveys() {
      this.loading = true
      try {
        const allSurveys = await getRecentSurveys()
        // сортируем по дате, самые новые в начале
        this.surveys = allSurveys.sort((a, b) => new Date(b.date) - new Date(a.date))
      } catch (err) {
        this.error = 'Ошибка загрузки опросов'
        console.error(err)
      } finally {
        this.loading = false
      }
    },
    async selectSurvey(survey) {
      try {
        const fullSurvey = await getSurvey(survey.id)
        const result = await getSurveyResult(survey.id)
        
        this.$emit('survey-selected', {
          survey: fullSurvey,
          result: result,
        })
      } catch (err) {
        console.error('Ошибка загрузки данных опроса:', err)
      }
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString('ru-RU')
    },
    statusLabel(status) {
      const labels = {
        draft: 'Черновик',
        in_progress: 'В процессе',
        completed: 'Завершен',
      }
      return labels[status] || status
    },
  },
}
</script>

<style scoped>
.history-card {
  background: white;
  border-radius: 8px;
  padding: 2rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.history-card h2 {
  margin-top: 0;
  margin-bottom: 1.5rem;
  color: #1a202c;
}

.loading,
.empty {
  text-align: center;
  color: #6b7280;
  padding: 2rem;
}

.surveys-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.survey-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.survey-item:hover {
  background: #f3f4f6;
  border-color: #2563eb;
}

.survey-info {
  flex: 1;
}

.survey-info h3 {
  margin: 0 0 0.5rem 0;
  font-size: 1rem;
  color: #1a202c;
}

.survey-meta {
  font-size: 0.9rem;
  color: #6b7280;
  margin: 0.25rem 0;
}

.survey-meta .status-completed {
  color: #22c55e;
  font-weight: 600;
}

.survey-meta .status-in_progress {
  color: #f59e0b;
  font-weight: 600;
}

.survey-meta .status-draft {
  color: #9ca3af;
  font-weight: 600;
}

.survey-questions {
  font-size: 0.85rem;
  color: #9ca3af;
  margin: 0.5rem 0 0 0;
}

.survey-action {
  margin-left: 1rem;
}

.btn-view {
  background: #2563eb;
  color: white;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  white-space: nowrap;
  transition: background 0.2s ease;
}

.btn-view:hover {
  background: #1d4ed8;
}

.status-no-result {
  font-size: 0.85rem;
  color: #9ca3af;
}
</style>